export type VisitTagArgs = {
    orgSlug: string,
    teamSlug?: string | null,
    tagName: string,
    query?: Record<string, string>
};

export default function VisitTag({
    orgSlug,
    teamSlug = null,
    tagName,
    query = {},
}: VisitTagArgs): void {
    const theRouter = window.$router;

    const theQuery: Record<string, string> = {
        ...query,
        tag: tagName,
        searchType: "tag",
    };

    if (tagName) {
        theQuery.search = tagName;
    }

    theRouter.push({
        name: teamSlug ? "org.team" : "org.dashboard",
        query: theQuery,
        params: {
            org: orgSlug,
            ...(teamSlug && { team: teamSlug }),
        },
    });
}
